import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona si todavía no reconoce letras?',
    a: 'Sí, de hecho es el punto de partida ideal. El programa comienza desde cero, activando los sonidos antes de las letras. No necesita saber nada previo.'
  }, {
    q: '¿Y si se frustra fácilmente?',
    a: 'El programa está diseñado exactamente para eso. Incluye una Guía Anti Frustración y las actividades son cortas y lúdicas para que nunca se sienta presionado.'
  }, {
    q: '¿Tengo que ser docente para usarlo?',
    a: 'Para nada. Está pensado para madres sin formación pedagógica. Cada actividad tiene instrucciones claras y simples. Solo necesitás 10 minutos y ganas de acompañarlo.'
  }, {
    q: '¿Cuánto tiempo real necesito dedicar?',
    a: '10 minutos por día. Eso es todo. El plan está organizado para que sea sostenible incluso en los días más ocupados.'
  }, {
    q: '¿En cuánto tiempo se ven cambios?',
    a: 'Muchas familias notan diferencias en la primera semana. Los cambios más sólidos en confianza y fluidez suelen verse entre la semana 2 y 3.'
  }, {
    q: '¿Y si no me resulta útil?',
    a: 'Tenés 7 días para probarlo. Si no ves claridad o avance, te devolvemos el dinero completo. Sin preguntas.'
  }];
  return <section className="w-full bg-cream-dark py-20 md:py-28 px-4" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-bold text-dark font-serif text-center mb-12" data-id="element-23">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((item, index) => <FAQItem key={index} question={item.q} answer={item.a} data-id="element-25" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm overflow-hidden transition-all duration-300" data-id="element-26">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-27">
        <span className="font-serif font-bold text-dark text-lg pr-4" data-id="element-28">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-olive shrink-0" data-id="element-29" /> : <ChevronDown className="w-5 h-5 text-olive shrink-0" data-id="element-30" />}
      </button>

      <div className={`px-6 transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-48 py-5 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-31">
        <p className="text-dark/80 leading-relaxed border-t border-gray-100 pt-4" data-id="element-32">
          {answer}
        </p>
      </div>
    </div>;
}